"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _AnimatorContent = _interopRequireDefault(require("./AnimatorContent"));

var _animatorChildStyles = _interopRequireDefault(require("../helpers/animator-child-styles"));

var _animatorChildClasses = _interopRequireDefault(require("../helpers/animator-child-classes"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _getDimensions = _interopRequireDefault(require("../helpers/get-dimensions"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/* eslint-disable */
var AnimatorChild = /*#__PURE__*/function (_Component) {
  _inheritsLoose(AnimatorChild, _Component);

  function AnimatorChild(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.styles = void 0;
    _this.node = void 0;
    _this.dimensions = void 0;
    _this.dimensions = {
      height: 0,
      width: 0
    };
    return _this;
  }

  var _proto = AnimatorChild.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.isDimensionAnimation()) {
      this.node = _reactDom["default"].findDOMNode(this.refs.content);
    }
  };

  _proto.isDimensionAnimation = function isDimensionAnimation() {
    var _this$props$animatorP = this.props.animatorProps,
        height = _this$props$animatorP.height,
        width = _this$props$animatorP.width;
    return height || width;
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var _ref$transition = _ref.transition,
        entering = _ref$transition.entering,
        exiting = _ref$transition.exiting;

    if (this.isDimensionAnimation() && (entering || exiting)) {
      this.setDimensions();
    }
  };

  _proto.setDimensions = function setDimensions() {
    var _this$props$animatorP2 = this.props.animatorProps,
        height = _this$props$animatorP2.height,
        width = _this$props$animatorP2.width;
    this.dimensions = (0, _getDimensions["default"])(this.node, {
      height: height,
      width: width
    });
  };

  _proto.render = function render() {
    var children = this.props.children;

    var _AnimatorChildStyle$g = new _animatorChildStyles["default"](this.props, this.dimensions).get(),
        style1 = _AnimatorChildStyle$g[0],
        style2 = _AnimatorChildStyle$g[1],
        style3 = _AnimatorChildStyle$g[2];

    var _AnimatorChildClasses = new _animatorChildClasses["default"](this.props).get(),
        class1 = _AnimatorChildClasses[0],
        class2 = _AnimatorChildClasses[1],
        class3 = _AnimatorChildClasses[2];

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: class1,
      style: style1
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: class2,
      style: style2
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: class3,
      style: style3
    }, /*#__PURE__*/_react["default"].createElement(_AnimatorContent["default"], {
      ref: "content"
    }, children))));
  };

  return AnimatorChild;
}(_react.Component);

var _default = AnimatorChild;
/* eslint-enable */

exports["default"] = _default;